import * as React from 'react';

/**
 * Breakpoints do UI-SPEC da Fase 06 e ADR-005 (tablet-first):
 * - Abaixo de 768px: Mobile/coletor em tela cheia ou drawer modal na sidebar.
 * - Entre 768px e 1024px: Tablet de galpão / iPad — sidebar inicia recolhida como rail (4rem / 64px).
 * - Acima de 1024px: Desktop / cockpit PCP — sidebar expandida por padrão (16rem / 256px).
 * Nenhum comportamento de navegação pode depender de hover (ADR-005 D3).
 */
export const MOBILE_BREAKPOINT = 768;
export const TABLET_BREAKPOINT = 1024;

export type ViewportMode = 'mobile-drawer' | 'tablet-rail' | 'desktop-expanded';

export function useViewportMode(): ViewportMode {
  const [mode, setMode] = React.useState<ViewportMode>(() => {
    if (typeof window === 'undefined') return 'desktop-expanded';
    const width = window.innerWidth;
    if (width < MOBILE_BREAKPOINT) return 'mobile-drawer';
    if (width < TABLET_BREAKPOINT) return 'tablet-rail';
    return 'desktop-expanded';
  });

  React.useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < MOBILE_BREAKPOINT) {
        setMode('mobile-drawer');
      } else if (width < TABLET_BREAKPOINT) {
        setMode('tablet-rail');
      } else {
        setMode('desktop-expanded');
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return mode;
}

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = React.useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < MOBILE_BREAKPOINT;
  });

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener('change', onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}
